const adminPaths = {
  basePath: "admin",
  children: {
    error: "error",
    farms: "farms",
  },
};

export default adminPaths;
